import { useGlobalSearchParams, useNavigation } from 'expo-router'
import { useEffect } from 'react'
import { Platform, StyleSheet, View } from 'react-native'

import FosterActionButton from '@/components/fosters/FosterActionButton'
import FosterPage from '@/components/fosters/FosterPage'
import FosterDetailHeaderContent from '@/components/navigation/header/FosterDetailHeaderContent'
import { useBreakpoint } from '@/hooks/useBreakpoint'
import FosterService from '@/services/fosterService'
import { useAppStore } from '@/store/useAppStore'

const headerRight = () => <FosterDetailHeaderContent />

const FosterDetail = () => {
  const navigation = useNavigation()
  const { isSmallScreen } = useBreakpoint()
  const { id: fosterId } = useGlobalSearchParams<{ id: string }>()

  const fosterName = FosterService.useCurrentFosterName(fosterId)
  const currentOrganization = useAppStore.use.currentOrganization().organization

  useEffect(() => {
    navigation.getParent()?.setOptions({
      title: fosterName || 'Add Foster',
      headerRight,
    })
  })

  return (
    <View style={styles.container}>
      <FosterPage fosterId={fosterId} />
      {isSmallScreen && currentOrganization?.id && Platform.OS === 'web' && (
        <FosterActionButton
          fosterId={fosterId}
          style={{
            paddingRight: 10,
            paddingBottom: 20,
          }}
        />
      )}
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    minHeight: 0,
  },
})

export default FosterDetail
